// import agents images
import Agent1 from "./assets/img/agents/agent1.png";

function importAll(r) {
  let images = [];
  r.keys().forEach((item, index) => { images.push(r(item)); });
  return images;
}

export const housesData = [
  {
    id: "35WBrighton",
    type: "House",
    name: "35 W Brighton Ave",
    description:
      "Newly built in 2017, this spacious home has an open floor plan, upgraded cabinetry and appliances, Quartz countertops and tile/glass backsplash, crown molding throughout, teak hardwood floors on the first level, Laundry/pantry room on the first level, MBR with walk-in closet and Master bath, Bay views, paver patio, and adjacent off-street parking for 6 cars. Beach, Bay, Restaurants, Ice Cream, Bakery, and Shopping all within 2 Blocks!",
    image: importAll(require.context('./assets/img/houses/35WBrighton', false, /^(?!.*-thumb).*\.webp$/))[0],
    imageLg:  importAll(require.context('./assets/img/houses/35WBrighton', false, /^(?!.*-thumb).*\.webp$/))[0],
    rentalType: "Weekly Rentals",
    address: "35 W Brighton Ave, Lavallette, NJ 07676",
    bedrooms: "4",
    bathrooms: "3",
    surface: "1,984 sq ft",
    year: "2017",
    price: "4,000",
    date: "5",
    agent: {
      image: Agent1,
      name: "Sunset Bay Properties, LLC",
      phone: "412-337-9034",
    },
    imageGallery: importAll(require.context('./assets/img/houses/35WBrighton', false, /^(?!.*-thumb).*\.webp$/)),
    imageGalleryThumbs: importAll(require.context('./assets/img/houses/35WBrighton', false, /-thumb\.webp$/)),
    weeklyRentals: [
      // {
      //   checkInDate: "5/2/2026",
      //   checkOutDate: "5/9/2026",
      //   weeklyRate: "$3,500",
      //   available: true,
      // },
      // {
      //   checkInDate: "5/9/2026",
      //   checkOutDate: "5/16/2026",
      //   weeklyRate: "$3,500",
      //   available: true,
      // },
      // {
      //   checkInDate: "5/16/2026",
      //   checkOutDate: "5/23/2026",
      //   weeklyRate: "$3,500",
      //   available: true,
      // },
      // {
      //   checkInDate: "5/23/2026",
      //   checkOutDate: "5/30/2026",
      //   weeklyRate: "$3,500",
      //   available: false,
      // },
      // {
      //   checkInDate: "5/30/2026",
      //   checkOutDate: "6/6/2026",
      //   weeklyRate: "$4,250",
      //   available: true,
      // },
      {
        checkInDate: "6/6/2026",
        checkOutDate: "6/13/2026",
        weeklyRate: "$4,250",
        available: true,
      },
      {
        checkInDate: "6/13/2026",
        checkOutDate: "6/20/2026",
        weeklyRate: "$4,250",
        available: true,
      },
      {
        checkInDate: "6/20/2026",
        checkOutDate: "6/27/2026",
        weeklyRate: "$4,250",
        available: false,
      },
      {
        checkInDate: "6/27/2026",
        checkOutDate: "7/4/2026",
        weeklyRate: "$5,500",
        available: false,
      },
      {
        checkInDate: "7/4/2026",
        checkOutDate: "7/11/2026",
        weeklyRate: "$5,500",
        available: false,
      },
      {
        checkInDate: "7/11/2026",
        checkOutDate: "7/18/2026",
        weeklyRate: "$5,125",
        available: false,
      },
      {
        checkInDate: "7/18/2026",
        checkOutDate: "7/25/2026",
        weeklyRate: "$5,125",
        available: false,
      },
      {
        checkInDate: "7/25/2026",
        checkOutDate: "8/1/2026",
        weeklyRate: "$5,150",
        available: false,
      },
      {
        checkInDate: "8/1/2026",
        checkOutDate: "8/8/2026",
        weeklyRate: "$5,125",
        available: false,
      },
      {
        checkInDate: "8/8/2026",
        checkOutDate: "8/15/2026",
        weeklyRate: "$5,125",
        available: true,
      },
      {
        checkInDate: "8/15/2026",
        checkOutDate: "8/22/2026",
        weeklyRate: "$5,250",
        available: false,
      },
      {
        checkInDate: "8/22/2026",
        checkOutDate: "8/29/2026",
        weeklyRate: "$5,500",
        available: false,
      },
      {
        checkInDate: "8/29/2026",
        checkOutDate: "9/5/2026",
        weeklyRate: "$5,500",
        available: false,
      },
      {
        checkInDate: "9/5/2026",
        checkOutDate: "9/12/2026",
        weeklyRate: "$5,500",
        available: false,
      },
      {
        checkInDate: "9/12/2026",
        checkOutDate: "9/19/2026",
        weeklyRate: "$4,500",
        available: false,
      },
      {
        checkInDate: "9/19/2026",
        checkOutDate: "9/26/2026",
        weeklyRate: "$4,000",
        available: true,
      },
      {
        checkInDate: "9/26/2026",
        checkOutDate: "10/3/2026",
        weeklyRate: "$4,000",
        available: true,
      },
      {
        checkInDate: "10/3/2026",
        checkOutDate: "10/10/2026",
        weeklyRate: "$3,500",
        available: true,
      },
      {
        checkInDate: "10/10/2026",
        checkOutDate: "10/17/2026",
        weeklyRate: "$3,500",
        available: true,
      },
      {
        checkInDate: "10/17/2026",
        checkOutDate: "10/24/2026",
        weeklyRate: "$3,500",
        available: true,
      },
      {
        checkInDate: "10/24/2026",
        checkOutDate: "10/31/2026",
        weeklyRate: "$3,500",
        available: true,
      },
    ],
  },
];
